// @ts-nocheck
import SceneLayer from "./layer";

export default class SceneLayerMarker extends SceneLayer {
	/**
	 * Vytvoreni vrstvy pro markery.
	 *
	 * @param  {String|Number} [id] Volitelne ID
	 */
	constructor(scene, itemId, id) {
		super(scene, itemId, id);

		this._markers = {};
		this._repositionOptions = null;
	}

	/**
	 * Destruktor.
	 */
	destroy() {
		for (const id in this._markers) {
			if (id in this._markers) {
				this._markers[id].marker.appended = false;
				this._markers[id].marker.destroy();
			}
		}

		this._markers = {};

		super.destroy();
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	// eslint-disable-next-line class-methods-use-this
	get featureInfo() {
		return {
			name: "SceneLayerMarker",
			type: "layer",
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		const rd = super.getCreateData();

		rd.markers = this._markers;

		return rd;
	}

	/**
	 * Pridani markeru.
	 *
	 * @param {SceneMarker|Array[SceneMarker]} marker Vstupni markery
	 * @param {Boolean} noRedraw Neprekreslovat mapu
	 */
	addMarker(marker, noRedraw?) {
		const markers = Array.isArray(marker) ? marker : [marker];

		this._addMarkers(markers);

		this._onChange(this._scene.featureEvent("layerMarkerAddMarkers", true, true), [markers, noRedraw]);
	}

	/**
	 * Odebrani markeru.
	 *
	 * @param {SceneMarker|Array[SceneMarker]} marker Vstupni markery
	 * @param {Boolean} noRedraw Neprekreslovat mapu
	 */
	removeMarker(marker, noRedraw?) {
		const markers = Array.isArray(marker) ? marker : [marker];

		this._removeMarkers(markers);

		this._onChange(this._scene.featureEvent("layerMarkerRemoveMarkers", true, true), [markers, noRedraw]);
	}

	/**
	 * Odstraneni vsech markeru.
	 */
	removeAll() {
		const all = [];

		for (const id in this._markers) {
			if (id in this._markers) {
				all.push(this._markers[id].marker);
			}
		}

		this._removeMarkers(all);

		super.removeAll();
	}

	/**
	 * Nastaveni redici funkce.
	 *
	 * @param {Object} opts
	 */
	setReposition(...args) {
		this._repositionOptions = args[0];

		this._onChange(this._scene.featureEvent("layerMarkerSetReposition", true, true), args);
	}

	/**
	 * Vycisteni vrstvy.
	 */
	clear() {
		for (const id in this._markers) {
			if (id in this._markers) {
				this._markers[id].appended = false;
			}
		}

		super.clear();
	}

	enableInteraction() {
		super.enableInteraction();

		Object.keys(this._markers).forEach(id => {
			const marker = this._markers[id].marker;

			marker.setActive(true);
		});
	}

	disableInteraction() {
		super.disableInteraction();

		Object.keys(this._markers).forEach(id => {
			const marker = this._markers[id].marker;

			marker.setActive(false);
		});
	}

	/**
	 * Ziskani pole se vsemi markery.
	 *
	 * @return {Array[SceneMarker]}
	 */
	getMarkers() {
		const result = [];

		for (const id in this._markers) {
			if (id in this._markers) {
				result.push(this._markers[id].marker);
			}
		}

		return result;
	}

	getShadowContainer(cb) {
		this._onChange(this._scene.featureEvent("featureGetShadowContainer", true, true), [cb]);
	}

	/**
	 * Pridani markeru.
	 *
	 * @param {SceneMarker|Array[SceneMarker]} markers Vstupni markery
	 * @private
	 */
	_addMarkers(markers) {
		for (let index = 0; index < markers.length; index++) {
			const item = markers[index];
			const obj = { /* polozka do marker cache */
				appended: false, /* ma prvky priple do stromu? */
				marker: item, /* znacka */
			};

			if (!this._interaction) {
				item.setActive(false);
			}

			this._markers[item.getId()] = obj;
			item.appended = true;
			item.sceneOwner = this;
		}
	}

	/**
	 * Odebrani markeru.
	 *
	 * @param {SceneMarker|Array[SceneMarker]} markers Vstupni markery
	 * @private
	 */
	_removeMarkers(markers) {
		for (let index = 0; index < markers.length; index++) {
			const marker = markers[index];
			const id = marker?.getId();

			if (!id || !(id in this._markers)) {
				return;
			}
			if (this._markers[id].appended) {
				this._unlink(this._markers[id]);
			}

			marker.appended = false;
			marker.sceneOwner = null;

			delete this._markers[id];
		}
	}

	/**
	 * Odstraneni markeru.
	 *
	 * @param {Object} obj Object obsahuji data pro marker.
	 * @private
	 */
	// eslint-disable-next-line class-methods-use-this
	_unlink(obj) {
		// container - remove all child?
		obj.appended = false;
	}
}
